<template>
  <div>
    <b-modal
      class="add-user-modal"
      id="bv-modal-example"
      hide-footer
      scrollable
      size="lg"
    >
      <template v-slot:modal-title> {{ modalType }} user </template>
      <b-form class="add-user-form" @submit="event.preventDefault()">
        <section class="add-user-form-section" :key="renderFields">
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-1"
            label="Username *"
            label-for="input-1"
            :invalid-feedback="'Please enter a user that does not exist.'"
            :state="state.username"
          >
            <b-form-input
              id="input-1"
              v-model="info.username"
              :state="state.username"
              @change="formValidations('username')"
              trim
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-9"
            label="Email *"
            label-for="input-9"
            :invalid-feedback="'Please enter a valid e-mail'"
            :state="state.email"
          >
            <b-form-input
              id="input-9"
              v-model="info.email"
              :state="state.email"
              trim
              @change="formValidations('email')"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-6"
            label="Name *"
            label-for="input-6"
            :invalid-feedback="'Please enter a name'"
            :state="state.name"
          >
            <b-form-input
              id="input-6"
              v-model="info.name"
              :state="state.name"
              trim
              @change="formValidations('name')"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-7"
            label="Surname *"
            label-for="input-7"
            :invalid-feedback="'Please enter a surname'"
            :state="state.surname"
          >
            <b-form-input
              id="input-7"
              v-model="info.surname"
              :state="state.surname"
              trim
              @change="formValidations('surname')"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="modalType === 'Add new'"
            class="add-user-form-section__field"
            id="fieldset-2"
            label="Password *"
            label-for="input-2"
            :invalid-feedback="
              `Please enter a password with a minimum of 6 characters.`
            "
            :state="state.password"
          >
            <b-form-input
              id="input-2"
              v-model="info.password"
              :state="state.password"
              trim
              @change="formValidations('password')"
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="modalType === 'Add new'"
            class="add-user-form-section__field"
            id="fieldset-3"
            label="Confirm Password *"
            label-for="input-3"
            :invalid-feedback="'Password does not match'"
            :state="state.confirmPassword"
          >
            <b-form-input
              id="input-3"
              v-model="info.confirmPassword"
              :state="state.confirmPassword"
              trim
              @change="formValidations('confirmPassword')"
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-4"
            label="Document *"
            label-for="input-4"
            :invalid-feedback="'Please enter a document'"
            :state="state.document"
          >
            <b-form-input
              id="input-4"
              v-model="info.document"
              :state="state.document"
              trim
              @change="formValidations('document')"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-5"
            label="Title *"
            label-for="input-5"
            :invalid-feedback="'Please enter a title'"
            :state="state.title"
          >
            <b-form-input
              id="input-5"
              v-model="info.title"
              :state="state.title"
              trim
              @change="formValidations('title')"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-8"
            label="Phone *"
            label-for="input-8"
            :invalid-feedback="'Please enter a phone'"
            :state="state.phone"
          >
            <b-form-input
              id="input-8"
              v-model="info.phone"
              :state="state.phone"
              trim
              @change="formValidations('phone')"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-10"
            label="Salesforce ID"
            label-for="input-10"
            :state="state.id_salesforce"
          >
            <b-form-input
              id="input-10"
              v-model="info.id_salesforce"
              :state="state.id_salesforce"
              trim
              @change="formValidations('id_salesforce')"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-13"
            label="Language *"
            label-for="input-13"
          >
            <b-form-select
              v-model="info.language_profile"
              :options="languageOptions"
              :state="state.language_profile"
              @change="formValidations('language_profile')"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field"
            id="fieldset-13"
            label="Teams"
            label-for="input-13"
          >
            <b-form-select
              v-model="info.team"
              :options="teamOptions"
              value-field="value"
              text-field="text"
              :state="state.team"
            ></b-form-select>
          </b-form-group>
        </section>
        <b-button
          @click="addRoleAndDepartment()"
          :disabled="activeSpinner"
          v-b-toggle.collapse-3
          class="add-user-form__submit-button m-1"
          ><b-spinner v-if="activeSpinner" small variant="light"></b-spinner>
          Add Role and Department</b-button
        >
        <section
          v-show="roleAndDepartment.length > 0"
          class="add-user-form-section"
          v-for="(element, index) in roleAndDepartment"
          :key="element + index"
        >
          <div v-if="activeName === 'first'">
            <b-button
              v-if="deleteRoleAndDtoSpinner[index] !== index"
              @click="
                deleteRoleAndDepartment(
                  index,
                  info.department_[index],
                  info.rol_[index]
                )
              "
              variant="danger"
              class="add-user-form-section__delete-button m-1"
              ><b-icon icon="x"></b-icon
            ></b-button>
            <b-spinner
              v-else
              class="add-user-form-section__delete-button m-1"
              small
              variant="danger"
            ></b-spinner>
          </div>
          <div v-else>
            <b-spinner
              v-if="
                info.rol_[index] === 1 &&
                  info.department_[index] ===
                    parseInt(currentDepartment.department_id)
              "
              v-show="deleteRoleAndDtoSpinner[index] === index"
              class="add-user-form-section__delete-button m-1"
              small
              variant="danger"
            ></b-spinner>
            <b-button
              v-else
              v-show="deleteRoleAndDtoSpinner[index] !== index"
              @click="
                deleteRoleAndDepartment(
                  index,
                  info.department_[index],
                  info.rol_[index]
                )
              "
              variant="danger"
              class="add-user-form-section__delete-button m-1"
              ><b-icon icon="x"></b-icon
            ></b-button>
          </div>
          <b-form-group
            class="add-user-form-section__field-role-department"
            id="fieldset-11"
            label="Department *"
            label-for="input-11"
          >
            <el-select
              :disabled="
                info.rol_[index] === 1 &&
                  activeName === 'second' &&
                  info.department_[index] ===
                    parseInt(currentDepartment.department_id)
              "
              v-model="info.department_[index]"
              filterable
              placeholder="Select a department"
              @change="addUserDepartmentAndRole(index)"
            >
              <el-option
                v-for="item in departmentOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </b-form-group>
          <b-form-group
            class="add-user-form-section__field-role-department"
            id="fieldset-12"
            label="Role *"
            label-for="input-12"
          >
            <el-select
              :disabled="
                info.rol_[index] === 1 &&
                  activeName === 'second' &&
                  info.department_[index] ===
                    parseInt(currentDepartment.department_id)
              "
              v-model="info.rol_[index]"
              filterable
              placeholder="Select a Role"
              @change="addUserDepartmentAndRole(index)"
            >
              <el-option
                v-for="item in roleOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </b-form-group>
        </section>
        <div class="add-user-form__submit-button-container">
          <b-overlay
            :show="busy"
            rounded
            opacity="0.6"
            spinner-small
            class="d-inline-block"
            @hidden="onHidden"
          >
            <b-button
              ref="button-accept"
              :disabled="busy"
              size="sm"
              @click="addUser"
              class="add-user-form__submit-button"
              ><i class="fa fa-plus"></i>
              {{ modalType === "Edit" ? "Update" : "Add" }}</b-button
            >
          </b-overlay>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { missingFieldsAlert, warningMessage } from "@/api/errorMessages";

export default {
  name: "NewUser",
  components: {},
  props: {
    activeName: String
  },
  data() {
    return {
      activeSpinner: false,
      modalType: null,
      info: {
        username: "",
        email: "",
        name: "",
        surname: "",
        password: "",
        confirmPassword: "",
        document: "",
        title: "",
        phone: "",
        language_profile: "",
        id_salesforce: "",
        // color: "",
        department_: [],
        rol_: [],
        team: "NO TEAM"
      },
      busy: false,
      state: {},
      roleAndDepartment: [],
      departmentOptions: [],
      roleOptions: [],
      validationRoleandDepartment: false,
      renderFields: 0,
      userId: null,
      oldUsername: "",
      deleteRoleAndDtoSpinner: [],
      languageOptions: [
        { value: "", text: "Select a language" },
        { value: "EN", text: "EN" },
        { value: "ES", text: "SP" },
        { value: "FB", text: "FB" }
      ],
      teamOptions: [
        { value: "NO TEAM", text: "NO TEAM" },
        { value: "SPARTANS", text: "SPARTANS" },
        { value: "ROCKET", text: "ROCKET" },
        { value: "G.O.A.T", text: "G.O.A.T" },
        { value: "BETA", text: "BETA" },
        { value: "GAMMA", text: "GAMMA" },
        { value: "ALPHA", text: "ALPHA" },
        { value: "OMEGA", text: "OMEGA" },
        { value: "ZETA", text: "ZETA" },
        { value: "DELTA", text: "DELTA" },
        { value: "SIGMA", text: "SIGMA" },
        { value: "KAPPA", text: "KAPPA" }
      ],
      validateDepartment: false
    };
  },
  watch: {
    modalType() {
      this.info.team =
        this.modalType === "Add new" ? "NO TEAM" : this.info.team;
    }
  },
  created() {
    this.cleanFields();
    this.getAllRoles();
    this.getAllDepartments();
  },
  methods: {
    cleanFields() {
      this.validationRoleandDepartment = false;
      this.roleAndDepartment = [];
      delete this.info?.color;
      const infoKeys = Object.keys(this.info);
      infoKeys.forEach(element => {
        this.info[element] = element !== "team" ? "" : this.info.team;
      });
      infoKeys.forEach(element => {
        this.state[element] = element !== "team" ? null : true;
      });
      this.info.department_ = [];
      this.info.rol_ = [];
      this.userId = null;
      this.oldUsername = "";
    },
    async showModal(modalType, userInfo, index) {
      this.currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.cleanFields();
      if (modalType === "Edit") {
        this.$emit("activeEditSpinner", index);
        this.userId = userInfo?.id;
        this.oldUsername = userInfo?.username;
        await this.getUserDataById(userInfo.id);
        this.info.language_profile = userInfo.language_profile
          ? userInfo.language_profile
          : "";
        this.$emit("activeEditSpinner", null);
      } else if (modalType === "Add new" && this.activeName === "second") {
        this.addRoleAndDepartment();
        this.info.rol_[0] = 1;
        this.info.department_[0] = parseInt(
          this.currentDepartment.department_id
        );
      }
      this.modalType = modalType;
      this.$bvModal.show("bv-modal-example");
    },
    async getAllRoles() {
      const body = {};
      let response = await this.$store.dispatch(
        "usersManagement/rolData/getAllRoles",
        body
      );
      this.roleOptions = response?.data;
    },
    async getAllDepartments() {
      let response = await this.$store.dispatch(
        "usersManagement/department/getAllDepartments"
      );
      this.departmentOptions = response?.data;
    },
    async getUserDataById(userId) {
      let responseUserById = await this.$store.dispatch(
        "usersManagement/getUserById",
        userId
      );
      responseUserById?.status === 200
        ? this.fillUserData(responseUserById?.data)
        : "";
      this.getUserRoleAndDepartment(userId);
    },
    async getUserRoleAndDepartment(userId) {
      this.activeSpinner = true;
      let responseUserRoleAndDepartment = await this.$store.dispatch(
        "usersManagement/getUserRoleAndDepartment",
        userId
      );
      this.activeSpinner = false;
      responseUserRoleAndDepartment?.status === 200
        ? this.fillRoleAndDepartment(responseUserRoleAndDepartment?.data)
        : "";
    },
    fillUserData(data) {
      const infoKeys = Object.keys(this.info);
      infoKeys.forEach(element => (this.info[element] = data[element]));
      this.info.department_ = [];
      this.info.rol_ = [];
    },
    fillRoleAndDepartment(data) {
      this.roleAndDepartment = [...data];
      data.forEach(
        (element, index) =>
          (this.info.department_[index] = Number(element.department_id))
      );
      data.forEach(
        (element, index) => (this.info.rol_[index] = Number(element.rol_id))
      );
    },
    addRoleAndDepartment() {
      this.roleAndDepartment.push({});
    },
    async deleteRoleAndDepartment(index, departmentValue, rolValue) {
      this.deleteRoleAndDtoSpinner[index] = index;
      if (this.roleAndDepartment.length > 0) {
        if (this.modalType === "Edit") {
          await this.deleteUserDepartmentAndRole(
            index,
            departmentValue,
            rolValue
          );
        }
        this.roleAndDepartment?.splice(index, 1);
        if (this.info.rol_.length > 0) {
          this.info.rol_?.splice(index, 1);
        }
        if (this.info.department_.length > 0) {
          this.info.department_?.splice(index, 1);
        }
      }
      this.deleteRoleAndDtoSpinner[index] = null;
    },
    async formValidations(type) {
      if (this.info[type]) {
        if (type === "username") {
          this.state[type] = await this.validateUsername();
          this.renderFields += 1;
        } else if (type === "email") {
          if (
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.info[type])
          ) {
            this.state[type] = true;
          } else {
            this.state[type] = false;
          }
        } else if (type === "password") {
          if (this.info[type].length > 5) {
            this.state[type] = true;
          } else {
            this.state[type] = false;
          }
        } else if (type === "confirmPassword") {
          if (
            this.info[type] === this.info.password &&
            this.info[type].length > 5
          ) {
            this.state[type] = true;
          } else {
            this.state[type] = false;
          }
        } else {
          this.state[type] = true;
        }
      } else {
        if (type === "id_salesforce") {
          this.state[type] = null;
        } else if (
          (type === "password" || type === "confirmPassword") &&
          this.modalType === "Edit"
        ) {
          this.state.password = true;
          this.state.confirmPassword = true;
        } else {
          this.state[type] = false;
        }
      }
      this.renderFields += 1;
    },
    async veryfyAllData() {
      const infoKeys = Object.keys(this.info);
      await infoKeys.forEach(element => this.formValidations(element));
      const checkedFields = infoKeys.some(
        element => element !== "id_salesforce" && !this.state[element]
      );
      return !checkedFields;
    },
    async validateUsername() {
      if (this.oldUsername === this.info.username) {
        return true;
      }
      let response = await this.$store.dispatch(
        "usersManagement/getAllUsers",
        this.info.username
      );
      const existingUsername = response?.status === 200 ? response?.data : null;
      return existingUsername.length === 0;
    },
    validateRoleandDepartment() {
      if (this.info.rol_.length === 0 || this.info.department_.length === 0) {
        return false;
      }
      return this.validateValues();
    },
    validateValues() {
      let allRoleValuesExist = false;
      let allDtValuesExist = false;
      if (
        this.info.rol_.length === this.roleAndDepartment.length &&
        this.info.department_.length === this.roleAndDepartment.length
      ) {
        allRoleValuesExist = this.roleAndDepartment.every(
          (element, index) => this.info.rol_[index]
        );
        allDtValuesExist = this.roleAndDepartment.every(
          (element, index) => this.info.department_[index]
        );
      }
      if (allRoleValuesExist && allDtValuesExist) {
        return true;
      }
      return false;
    },
    async addUser() {
      this.validateDepartment = false;
      this.validateDepartments();
      const fieldValidation = await this.veryfyAllData();
      this.validationRoleandDepartment = this.validateRoleandDepartment();
      if (this.validateDepartment) {
        if (fieldValidation && this.validationRoleandDepartment) {
          this.busy = true;
          this.info.color = "";
          let response;
          if (this.modalType === "Add new") {
            response = await this.$store.dispatch(
              "usersManagement/addUser",
              this.info
            );
          } else {
            await this.getUserRoleAndDepartment(this.userId);
            response = await this.updateUser();
          }
          if (response?.status == 201 || response?.status == 200) {
            const msg = this.modalType === "Add new" ? "created" : "updated";
            this.swal({
              title: "Good job!",
              text: `The user has been ${msg}!`,
              icon: "success",
              button: "OK"
            });
            this.$emit("getUsers");
            this.$bvModal.hide("bv-modal-example");
            this.cleanFields();
          }
          delete this.info?.color;
        } else {
          delete this.info?.color;
          const msg =
            fieldValidation && !this.validationRoleandDepartment
              ? "Please validate all department and role fields to be assigned to the user."
              : "Please validate required fields";
          missingFieldsAlert(msg);
        }
      } else {
        missingFieldsAlert(
          "please validate that one of these departments is associated with the user 'ltl o otr'"
        );
      }
      this.busy = false;
    },
    async updateUser() {
      let response;
      const acceptChanges = await warningMessage(
        "Changes in user will be reflected inmediately"
      );
      if (acceptChanges) {
        const data = {};
        data.userId = this.userId;
        data.payload = { ...this.info };
        response = await this.$store.dispatch(
          "usersManagement/updateUser",
          data
        );
        return response;
      }
      this.swal("You can continue editing the user");
      return response;
    },
    async deleteUserDepartmentAndRole(index, departmentValue, rolValue) {
      if (departmentValue && rolValue) {
        this.deleteRoleAndDtoSpinner[index] = index;
        const data = {};
        data.userId = this.userId;
        data.rolId = rolValue;
        data.departmentId = departmentValue;
        const response = await this.$store.dispatch(
          "usersManagement/deleteUserDepartmentAndRole",
          data
        );
        this.deleteRoleAndDtoSpinner[index] = null;
        if (response?.status === 204) {
          this.getUserRoleAndDepartment(this.userId);
        }
      }
    },
    async addUserDepartmentAndRole(index) {
      if (
        this.info.rol_[index] &&
        this.info.department_[index] &&
        this.modalType === "Edit"
      ) {
        const data = {};
        data.user_ = this.userId;
        data.rol_ = this.info.rol_[index];
        data.department_ = this.info.department_[index];
        const response = await this.$store.dispatch(
          "usersManagement/addUserDepartmentAndRole",
          data
        );
        if (response?.status === 200) {
          this.getUserRoleAndDepartment(this.userId);
        }
      }
    },
    onHidden() {
      this.$refs["button-accept"].focus();
    },
    validateDepartments() {
      this.info.department_.forEach(element => {
        for (let i = 0; i < this.departmentOptions.length; i++) {
          if (this.departmentOptions[i].id === element) {
            const selectedDepartments = [];
            selectedDepartments.push(this.departmentOptions[i].name);
            selectedDepartments.forEach(department => {
              if (department.includes("ltl") || department.includes("otr")) {
                return (this.validateDepartment = true);
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.add-user-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &__submit-button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  &__submit-button {
    @include primary-button;
    margin: 1rem 0;
  }
}

.add-user-form-section {
  @include flex-wrap(space-between);
  flex-direction: row;
  align-items: flex-start;
  margin-top: 10px;
  &__field {
    width: 48%;
    font-size: 12px;
    color: $color-gray-shadow;
  }
  &__field-role-department {
    width: 40%;
    font-size: 12px;
    color: $color-gray-shadow;
  }
  &__delete-button {
    padding: 0;
  }
}

::v-deep .el-select .el-input__inner:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

::v-deep .p-dropdown {
  height: 37.99px;
  color: $color-gray-shadow;
}
::v-deep .p-dropdown:not(.p-disabled):hover {
  border-color: #ced4da;
}

@media (max-width: 650px) {
  .add-user-form-section {
    flex-direction: column;
    width: 100%;
    &__field {
      width: 100%;
    }
  }
  .add-user-form-section[data-v-38033f60] {
    flex-direction: row;
    width: auto;
  }
}
</style>
